import { inject, provideAppInitializer, type EnvironmentProviders } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { UrlsBancoService } from '@core/services/config-banco/urls-banco.service';

export function inicializarUrlsBanco(urlsBancoService: UrlsBancoService): Promise<void> {
  return firstValueFrom(urlsBancoService.inicializar());
}

export function proveedorUrlsBanco(): EnvironmentProviders {
  return provideAppInitializer(() => inicializarUrlsBanco(inject(UrlsBancoService)));
}
